import { render } from "./RegencyListComponent.vue?vue&type=template&id=52825d40"
import script from "./RegencyListComponent.vue?vue&type=script&lang=js"
export * from "./RegencyListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/kinarya-jqdev/jqdev/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__